
import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import User from '@/models/User'
import { Invoice } from '@/models/accounting/Invoice'
import ExactAuthorizationDialog from '@/components/Accounting/ExactAuthorizationDialog.vue'
import InvoiceCreator from '@/components/Transport/Accounting/InvoiceCreator.vue'
import InvoiceType from '@/enums/InvoiceType'
import { FlatTransport } from '@/models/FlatTransport'
import { Transport } from '@/models/Transport'

@Component({
	components: {
		InvoiceCreator,
		ExactAuthorizationDialog
	}
})
export default class InvoiceCreatorDialog extends Vue {
	@Prop({ required: false, default: () => [] })
	transports!: Array<FlatTransport> | Array<Transport>

	@Prop({ required: false, default: false })
	opened!: boolean

	@Prop({ required: false, default: false })
	preview!: boolean

	@Prop({ required: false, default: false })
	sending!: boolean

	@Prop({ required: false, default: false })
	showingTruckTransports!: boolean

	@Prop({ required: false, default: null })
	invoice!: Invoice | null

	@Prop({ required: false, default: null })
	invoiceType!: InvoiceType | null

	@Prop({ required: false, default: false })
	isCombinedInvoice!: boolean

	@Prop({ required: false, default: false })
	isExternal!: boolean

	isLoading: boolean = false
	initialized: boolean = false
	initializing: boolean = false
	authorizationDialogOpened: boolean = false
	authorizationKey = 1
	authorizationDialogLabel: string | null = null

	@Watch('opened')
	async onOpenedChange() {
		if (!this.initializing && !this.initialized) {
			await this.initialize()
		}
	}

	async initialize() {
		this.initializing = true

		try {
			await this.fetchFinancialConnection()
			this.initializing = false
			this.initialized = true
		} catch (e: any) {
			switch (e.message) {
				case 'Financial connection not found':
					this.authorizationDialogLabel = 'notFound'
					break
				case 'Financial connection expired':
					this.authorizationDialogLabel = 'expired'
					break
				default:
					this.authorizationDialogLabel = null
			}

			const user = await User.fetchMeLazy()
			if (user.getFinancialConnection() && user.getFinancialConnection()?.isExact()) {
				this.openExactAuthDialog()
			}
			await this.closeCreator()
		}
	}

	async fetchFinancialConnection() {
		const user = await User.fetchMe()

		if (!user?.getFinancialConnection()) {
			throw new Error('Financial connection not found')
		}
		if (user.getFinancialConnection()?.isExpired()) {
			throw new Error('Financial connection expired')
		}
	}

	openExactAuthDialog() {
		this.authorizationDialogOpened = true
	}

	async closeAuthorizationDialog() {
		this.authorizationDialogOpened = false

		this.authorizationKey++
	}

	async closeCreator() {
		this.$emit('closed')
		await this.$nextTick()
		this.initializing = false
		this.initialized = false
	}
}
